import { jsx as r } from "react/jsx-runtime";
import { Block as e } from "../block/block.js";
import { Flex as f } from "../flex/flex.js";
import { forwardRef as i } from "react";
const d = i(
  ({ children: o, ...m }, t) => /* @__PURE__ */ r(f, { asChild: !0, ...m, ref: t, children: /* @__PURE__ */ r(e, { children: o }) })
);
export {
  d as FlexBlock
};
